import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let ECampaignStreamActionChannel;
(function (ECampaignStreamActionChannel) {
  ECampaignStreamActionChannel["Sms"] = "sms";
  ECampaignStreamActionChannel["Email"] = "email";
  ECampaignStreamActionChannel["Voice"] = "voice";
})(ECampaignStreamActionChannel || (ECampaignStreamActionChannel = {}));
export let ECampaignStreamActionAct;
(function (ECampaignStreamActionAct) {
  ECampaignStreamActionAct["SendMessage"] = "send-message";
})(ECampaignStreamActionAct || (ECampaignStreamActionAct = {}));
export let ECampaignStreamStatus;
(function (ECampaignStreamStatus) {
  ECampaignStreamStatus["Created"] = "created";
})(ECampaignStreamStatus || (ECampaignStreamStatus = {}));
export const fieldsCampaignStream = _extends({}, fieldsIBaseModel, {
  actions: {
    type: 'Object',
    array: true
  },
  campaign: {
    type: 'ID',
    ref: EModel.Campaign
  },
  conditionsSet: {
    type: 'ID',
    ref: EModel.ConditionsSet
  },
  stats: {
    type: 'Object'
  },
  status: {
    type: 'Option',
    values: ECampaignStreamStatus
  },
  title: {
    type: 'Text'
  }
});